import React from 'react';
import '../template-file-css/document-file-template.css';


export const RNFI_LabConsent = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RNFI_LabConsent' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'> <center> <h3> <b> RAVENS NEST FOUNDATION, INC. </b> </h3> </center>
                </p>
                <p className='w-750'> <center> <h4> <b> Patient Consent for Labs/Alcohol/Drug Testing Form </b> </h4> </center>
                </p>

                <p className='w-750'> I hereby give my consent for Ravens Nest Foundation, Inc.(the Practice)
                </p>

                <p className='w-750'> I agree to have Ravens Nest Foundation, INC administer labs/urine drug screen.
                </p>

                <p className='w-750'> I agree that the following clinics: Ravens Nest, Quest Diagnostic or NexGen Lab may collect these specimens for these tests
                    and may test them or forward them to a testing laboratory designated by the company for analysis. I further agree and hereby authorize release of the results of said test to the Ravens Nest Foundation, INC. I further agree that a reproduced copy of this consent and release form shall have the same force and effect as the original.
                </p>

                <p className='w-750'> I have carefully read the foregoing and fully understand its contents. I acknowledge that my signing of this consent and
                    release form is a voluntary act on my part and that I have not been coerced into signing this document by anyone.
                </p>

                <table>
                    <tr>
                        <td className='signature w-375'> &nbsp; </td>
                        <td className='signature w-375'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature of Patient or Legal Guardian </td>
                        <td className='small w-375'> Patient Name: </td>
                    </tr>
                </table>


            </div>
        </form>

    )
}











